export function computeVoteChoicePercentage(poll, choice) {

  const totalVotesCount = poll.totalVotesCount;
  const votesCount = choice.votesCount;

  if (votesCount === 0) {
    return 0;
  }

  if (totalVotesCount === 0) {
    return 0;
  }

  const percentage = (votesCount / totalVotesCount) * 100;

  let result = null;

  if ((percentage % 1) === 0) {
    result = percentage;
  }

  result = percentage.toFixed(0);

  return result;

}

export function isPollActive(poll) {

  const endsAt = poll.endsAt;

  if (endsAt === null) {
    return true;
  }

  const now = Date.now();

  if (endsAt >= now) {
    return true;
  }

  return false;

}

export function canDisplayEndedPollView(userId, poll) {

  if (userId === null) {
    return true;
  }

  return isPollActive(poll) === false;

}

export function canDisplayActivePollView(userId, poll) {

  if (userId === null) {
    return false;
  }

  if (isPollActive(poll) === false) {
    return false;
  }

  return true;

}

export function canDisplayChoicesWithoutStats(userId, poll) {

  if (poll.voterIds.indexOf(userId) !== -1) {
    return false;
  }

  return poll.displayResultsAfterParticipation === true;

}

export function filterEmptyPollChoices(poll) {

  const choices = poll.choices;

  let index = 0;

  while (index < choices.length) {

    const choice = choices[index];

    if (choice.published === false || choice.name.trim() === '') {
      choices.splice(index, 1);
    } else {
      index++;
    }

  }

}